import {
  TransportMovementsData,
  TransportPositionsData,
  EntitiesWrapper,
  LoadDetailsData,
  TransportMovementsSearch,
} from '@/types';
import {
  Core,
  LOAD_DETAILS_BY_LOADID,
  LOAD_LOGS_BY_LOADID,
  TRANSPORT_MOVEMENTS,
  TRANSPORT_POSITIONS,
} from '../Core';

class TransportMovements extends Core {
  getTransportMovements = async (reqDate: TransportMovementsSearch) =>
    this.post<TransportMovementsData>(TRANSPORT_MOVEMENTS(), reqDate);

  getloadDetails = async (id: number) =>
    this.get<LoadDetailsData>(LOAD_DETAILS_BY_LOADID(id));

  getMovementsLogs = async (id: number) =>
    this.get<EntitiesWrapper>(LOAD_LOGS_BY_LOADID(id));

  getTransportPositions = async () =>
    this.get<TransportPositionsData>(TRANSPORT_POSITIONS());
}

export const transportMovements = new TransportMovements();
